import { axios } from "../../lib";
import toast from "react-hot-toast";
import TYPES from "../types";

const altBikeData = (data) => ({
  type: TYPES.ALT_BIKES,
  data
});

export const getBikes =
  ({ page = 1, count = 10 }, search) =>
    async (dispatch) => {
      try {
        const { status, ...response } = await axios.get(
          `/admin/riders?page=${page}&limit=${count}${search || ''}`
        );
        if (!search) {
          dispatch(altBikeData(response.data));
        }
        return {...response };
      } catch (error) {
        // Handle 404 or other errors silently - riders endpoint may not exist
        console.log('Riders endpoint not available:', error);
        dispatch(altBikeData({ data: [], pagination: {} }));
        return { status: error.response?.status || 500, data: [], pagination: {} };
      }
    };

export const altBike = (data, action, navigate) => async (dispatch) => {
  try {
    const { status, ...response } =
      action === "add"
        ? await axios.post("/admin/bikes", data)
        : action === "update"
          ? await axios.put(`/admin/bikes/${data.id}`, {
            bikerName: data.bikerName,
            isActive: data.isActive
          })
          : await axios.delete(`/admin/bikes/${data.id}`);

    navigate && navigate("/dashboard/bikes")
    if (status === 201 || status === 200) {
      await dispatch(getBikes({}));
      toast.success(response.message);
      return { status, ...response };
    }
  } catch ({ response }) {
    toast.error(response?.data?.message || 'Failed to process bike operation');
  }
};

export const getSingleBike = (data) => async (dispatch, getState) => {
  try {
    const { status, ...response } = await axios.post(`/admin/bikes/${data}`)
    return response
  } catch ({ response }) {
    toast.error(response?.data?.message || 'Failed to fetch bike');
  }
}

export const getBikeDetails = async (id) => {
  return await axios.get(`/admin/bikes/${id}`);
};

export const AttachBike = (data, navigate) => async (dispatch) => {
  try {
    const { status, ...response } = await axios.post(`/admin/add_bike_to_order`, {
      bikeId: data.ride.id,
      orderId: data.orderId
    });
    if (response.status === 200) {
      navigate("/dashboard/orders")
      toast.success(response.data.message);

    }
  } catch ({ response }) {

    toast.error(response?.data?.message || 'Failed to attach bike');
  }
};
